export default [
    {
        path: '/intake',
        name: 'intake',
        view: 'intake/Intake',
        middlewares: [],
    },
]
